export default class WindowEventsHandler {
    /* eslint no-param-reassign: 0 */
    static enableUnloadMessage() {
        window.onbeforeunload = e => {
            const confirmationMessage = 'There are unsaved changes on this page, are you sure you want to leave?';

            e.returnValue = confirmationMessage;
            return confirmationMessage;
        };
    }

    static disableUnloadMessage() {
        window.onbeforeunload = () => {};
    }

    static scrollToTop() {
        window.scrollTo(0, 0);
    }
}



// WEBPACK FOOTER //
// ./src/services/WindowEventsHandler.js